import { render, staticRenderFns } from "./CalculationsHistoryPopUp.vue?vue&type=template&id=d9ddc258&scoped=true&"
import script from "./CalculationsHistoryPopUp.vue?vue&type=script&lang=js&"
export * from "./CalculationsHistoryPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ddc258",
  null
  
)

export default component.exports